import { ActionsHook } from "@/lib/Components/Actions/ActionGroupButtons";
import { SupplierAdminContactListItem } from "@/app/Suppliers/GraphQL/supplierAdminContactList";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { SupplierAdminContactUpdateDialog } from "@/app/Suppliers/Components/Dialogs/SupplierAdminContactUpdateDialog";
import { useConfirmDeleteDialog } from "@/lib/Components/Dialog/Hooks/useConfirmDeleteDialog";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { deleteSupplierAdminContactMutation } from "@/app/Suppliers/GraphQL/supplierAdminContactMutations";

export function useSupplierAdminContactActions(): ActionsHook<SupplierAdminContactListItem> {
  const { open } = useDialog(SupplierAdminContactUpdateDialog);
  const { open: deleteContact } = useConfirmDeleteDialog();
  const { mutateAsync } = useGqlMutation(deleteSupplierAdminContactMutation);

  return (item) => {
    return [
      {
        label: "Actions",
        items: [
          {
            actions: [
              {
                label: "Edit",
                Icon: PencilIcon,
                handleAction: () => {
                  open({ supplierAdminContactId: item.id });
                },
              },
            ],
          },
          {
            actions: [
              {
                label: "Delete",
                Icon: TrashIcon,
                color: "red",
                handleAction: () => {
                  deleteContact({
                    message: "Are you sure you want to delete this contact?",
                    buttonText: "Delete",
                    title: "Delete Contact",
                    onDelete: () => mutateAsync({ id: item.id }),
                  });
                },
              },
            ],
          },
        ],
      },
    ];
  };
}
